import { useEffect, useState } from 'react';
import { hysteriFetch, wrappers } from 'hysterics';
import { useRequestData } from 'wsm-common-data';
import { useAccountId } from '../features/accountId/accountIdSlice';
import { getEnv } from '../utils/getEnv';

const initState = { isLoading: true, errorMsg: null, data: null };

const timeouts = {
	localhost: 5000,
	nonprod: 3000,
	prod: 1500
};

const env = getEnv();

const fetchLocations = hysteriFetch('ws-locations', {
	[wrappers.circuitBreaker.contextKey]: {
		timeout: timeouts[env] || 4000
	},
	[wrappers.timeout.contextKey]: {
		timeout: timeouts[env] || 4000
	},
	[wrappers.retry.contextKey]: {
		retries: 0
	}
});

export const useFetchLocations = (postalCode) => {
	const [fetchState, setFetchState] = useState(initState);
	const { locale } = useRequestData();
	const accountId = useAccountId();
	useEffect(() => {
		if (postalCode) {
			const fetchData = async () => {
				const urlObj = new URL(
					'/api/widget/ws-locations/locations',
					window.location.origin
				);
				urlObj.searchParams.set('postalCode', postalCode);
				urlObj.searchParams.set('locale', locale);
				urlObj.searchParams.set('accountId', accountId);
				setFetchState({ ...initState });
				const urlString = urlObj.toString();
				try {
					const data = await fetchLocations(urlString);
					setFetchState({ isLoading: false, errorMsg: null, data });
				} catch (error) {
					setFetchState({
						isLoading: false,
						errorMsg: error.message,
						data: null
					});
				}
			};
			fetchData();
		}
	}, [postalCode, locale, accountId]);

	return fetchState;
};
